import { render, staticRenderFns } from "./__arranged_purchase_list.vue?vue&type=template&id=1d0a7eb9&"
import script from "./__arranged_purchase_list.vue?vue&type=script&lang=js&"
export * from "./__arranged_purchase_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports